import React, { useState } from 'react';
import { st, classes } from './ReportWrapper.st.css';
import {
  Text,
  TextTypography,
  RadioButtonGroup,
  RadioButton,
  Button,
  ButtonPriority,
  HoverStyles,
} from '@wix/wix-ui-tpa/cssVars';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { reportDialogOptions } from './helper';
import { UNWANTED_OR_SPAM } from './reportTypes';
import { setOpenedModal } from '../../../Services/Modals.service';
import { MODAL_TYPES } from '../../../../Constants/Modals.Constants';
import { reportItems } from '../../../Services/ReportModal.service';
import {
  getAppSettings,
  getSettingsData,
} from '../../../Services/AppSettings.service';
import useObservable from '../../../../Shared/Hooks/useObservable.Hook';

const ReportWrapper = ({ currentItem, handleOnClose }: any) => {
  const { t }: { t: any } = useTranslation();
  const [error1, AppSettings]: any = useObservable(getAppSettings());
  const [, settingsData]: any = useObservable(getSettingsData());
  const borderRadius =
    settingsData?.settings?.designSettings?.buttonCornerRadius ?? 0;

  const isMobile = getAppSettings !== undefined ? AppSettings?.isMobile : '';
  const [state, setState] = useState({
    selectedOption: UNWANTED_OR_SPAM,
  });
  const title = t('app.widget.report.dialog.title');
  const subTitle = t('app.widget.report.dialog.options.title');
  const secondaryButtonText = t('app.widget.report.dialog.cancel');
  const primaryButtonText = t('app.widget.report.dialog.report');
  const radioButtonOptions = reportDialogOptions(t);
  const { selectedOption } = state;
  const secondaryButtonHandleOnClick = () => {
    handleOnClose && handleOnClose();
  };
  const primaryButtonHandleOnClick = () => {
    reportItems({ item: currentItem, reason: state.selectedOption });
  };
  return (
    <div className={classes.ReportWrapperContainer}>
      <div className={classes.ReportTitleContainer}>
        <Text className={classes.modalTitle}>{title}</Text>
      </div>
      <div className={classes.RadioButtonOptionsContainer}>
        <Text className={classes.modalSubTitle}>{subTitle}</Text>
        <RadioButtonGroup
          name="areAreRadio"
          value={selectedOption}
          withSpacing
          onChange={(value: any) => {
            setState({ selectedOption: value });
          }}
        >
          {radioButtonOptions?.map((item: any) => (
            <RadioButton
              className={classes.radioButtonWrapper}
              value={item?.value}
              label={item?.label}
            />
          ))}
        </RadioButtonGroup>
      </div>
      <div
        className={
          isMobile !== undefined && isMobile === true
            ? classes.reportActionsMobileContainer
            : classes.reportActionsContainer
        }
      >
        <Button
          upgrade
          priority={ButtonPriority.basicSecondary}
          className={st(classes.secondaryButtonContainer, {
            isDesktop: !isMobile,
          })}
          hoverStyle={HoverStyles.colorChange}
          style={{ borderRadius }}
          onClick={secondaryButtonHandleOnClick}
        >
          {secondaryButtonText}
        </Button>
        <Button
          upgrade
          className={st(classes.primaryButtonContainer, {
            isDesktop: !isMobile,
          })}
          hoverStyle={HoverStyles.colorChange}
          style={{ borderRadius }}
          onClick={primaryButtonHandleOnClick}
        >
          {primaryButtonText}
        </Button>
      </div>
    </div>
  );
};

export default ReportWrapper;
